class FreeGiftSection extends HTMLElement {
  constructor() {
    super();
    this.sectionHeading = this.dataset.sectionHeading || 'Tillykke med din gratis gave!';
    this.giftName = this.dataset.giftName || '';
    this.giftImage = this.dataset.giftImage || '';
    this.giftPrice = parseInt(this.dataset.giftPrice || 0, 10);
    this.giftComparePrice = this.dataset.giftComparePrice ? parseInt(this.dataset.giftComparePrice, 10) : null;
    this.threshold = parseInt(this.dataset.threshold || 0, 10);
    this.progressTextTemplate = this.dataset.progressText || 'Brug [amount] mere, og få [gift_name]';
    this.successTextTemplate = this.dataset.successText || 'Tillykke, du har nu fået GRATIS [gift_name].';
    this.descriptionTextTemplate = this.dataset.descriptionText || 'Gratis gave: [gift_name]';
    this.requirementTextTemplate = this.dataset.requirementText || 'Ved køb over [amount].';
    this.freeText = this.dataset.freeText || 'Gratis';
  }

  connectedCallback() {
    this.render();
  }

  static get observedAttributes() {
    return ['data-earned', 'data-remaining', 'data-visible'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.render();
    }
  }

  render() {
    const isVisible = this.dataset.visible === 'true';
    const isEarned = this.dataset.earned === 'true';
    const remaining = parseInt(this.dataset.remaining || this.threshold, 10);
    
    if (!isVisible) {
      this.style.display = 'none';
      return;
    }

    this.style.display = 'block';

    const thresholdAmount = this.formatMoney(this.threshold);
    const descriptionText = this.descriptionTextTemplate
      .replace('{gift_name}', this.giftName)
      .replace('[gift_name]', this.giftName);
    
    const requirementText = this.requirementTextTemplate
      .replace('{amount}', thresholdAmount)
      .replace('[amount]', thresholdAmount);
    
    const comparePriceHtml = this.giftComparePrice 
      ? `<s class="free-gift-section__compare-price">${this.formatMoney(this.giftComparePrice)}</s>`
      : '';

    const amountText = this.formatMoney(remaining);
    const pendingMessage = this.progressTextTemplate
      .replace('{amount}', amountText)
      .replace('[amount]', amountText)
      .replace('{gift_name}', this.giftName)
      .replace('[gift_name]', this.giftName);

    const successMessage = this.successTextTemplate
      .replace('{gift_name}', this.giftName)
      .replace('[gift_name]', this.giftName);

    const messageText = isEarned ? successMessage : pendingMessage;
    const checkmarkClass = isEarned ? 'free-gift-section__checkmark is-earned' : 'free-gift-section__checkmark';

    this.innerHTML = `
      <div class="free-gift-section__content">
        <div class="free-gift-section__gift">
          <div class="free-gift-section__image-wrapper">
            <img class="free-gift-section__image" src="${this.giftImage}" alt="${this.giftName}" loading="lazy" width="80" height="80">
            <span class="${checkmarkClass}">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="10" fill="#00b67a"/>
                <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
          <div class="free-gift-section__details">
            <p class="free-gift-section__description">${descriptionText}</p>
            <p class="free-gift-section__requirement">${requirementText}</p>
            <div class="free-gift-section__price">
              ${comparePriceHtml}
              <span class="free-gift-section__free-text">${this.freeText}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(cents / 100);
  }
}

customElements.define('free-gift-section', FreeGiftSection);

